function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { PureComponent } from 'react';
import Log from '@deephaven/log';
import { memoizeClear } from '@deephaven/grid';
import { FormatterUtils, TableUtils } from '@deephaven/jsapi-utils';
import { PromiseUtils, assertNotNull } from '@deephaven/utils';
import IrisGridUtils from "../IrisGridUtils.js";
var log = Log.module('TableSaver');
var UNFORMATTED_DATE_PATTERN = "yyyy-MM-dd'T'HH:mm:ss.SSSSSSSSS z";
function isUpdateEventData(data) {
  return data.added !== undefined;
}
function assertIsUpdateEventData(data) {
  if (!isUpdateEventData(data)) {
    throw new Error('event is not UpdateEventData');
  }
}
export default class TableSaver extends PureComponent {
  static csvEscapeString(str) {
    return "\"".concat(str.replace(/"/g, '""'), "\"");
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "sw", void 0);
    _defineProperty(this, "port", void 0);
    _defineProperty(this, "fileWriter", void 0);
    _defineProperty(this, "table", void 0);
    _defineProperty(this, "tableSubscription", void 0);
    _defineProperty(this, "columns", void 0);
    _defineProperty(this, "fileName", void 0);
    _defineProperty(this, "includeColumnHeaders", void 0);
    _defineProperty(this, "useUnformattedValues", void 0);
    _defineProperty(this, "chunkRows", void 0);
    _defineProperty(this, "gridRanges", void 0);
    _defineProperty(this, "gridRangeCounter", void 0);
    _defineProperty(this, "rangedSnapshotsTotal", void 0);
    _defineProperty(this, "rangedSnapshotCounter", void 0);
    _defineProperty(this, "snapshotsTotal", void 0);
    _defineProperty(this, "snapshotCounter", void 0);
    _defineProperty(this, "snapshotsBuffer", void 0);
    _defineProperty(this, "currentSnapshotIndex", void 0);
    _defineProperty(this, "snapshotPending", void 0);
    _defineProperty(this, "cancelableSnapshots", void 0);
    // Due to an open issue in Chromium, readableStream.cancel() is never called when a user cancel the stream from Chromium's UI and the stream goes on even it's canceled.
    // Instead, we  monitor the pull() behavior from the readableStream called when the stream wants more data to write.
    // If the stream doesn't pull for long enough time, chances are the stream is already canceled, so we stop the stream.
    // Issue ticket on Chromium: https://bugs.chromium.org/p/chromium/issues/detail?id=638494
    _defineProperty(this, "streamTimeout", void 0);
    _defineProperty(this, "snapshotHandlerTimeout", void 0);
    _defineProperty(this, "downloadStartTime", void 0);
    _defineProperty(this, "iframe", void 0);
    _defineProperty(this, "useBlobFallback", void 0);
    _defineProperty(this, "getCachedCustomColumnFormatFlag", memoizeClear(FormatterUtils.isCustomColumnFormatDefined, {
      max: 10000
    }));
    this.handlePortMessage = this.handlePortMessage.bind(this);
    this.handleSnapshotResolved = this.handleSnapshotResolved.bind(this);
    this.handleDownloadTimeout = this.handleDownloadTimeout.bind(this);
    this.state = {};
    this.gridRanges = [];
    this.gridRangeCounter = 0;
    this.rangedSnapshotsTotal = [];
    this.rangedSnapshotCounter = 0;
    this.includeColumnHeaders = true;
    this.useUnformattedValues = false;
    this.snapshotsTotal = 0;
    this.snapshotCounter = 0;
    this.snapshotsBuffer = new Map();
    this.currentSnapshotIndex = 0;
    this.snapshotPending = 0;
    this.cancelableSnapshots = [];

    // Due to an open issue in Chromium, readableStream.cancel() is never called when a user cancel the stream from Chromium's UI and the stream goes on even it's canceled.
    // Instead, we  monitor the pull() behavior from the readableStream called when the stream wants more data to write.
    // If the stream doesn't pull for long enough time, chances are the stream is already canceled, so we stop the stream.
    // Issue ticket on Chromium: https://bugs.chromium.org/p/chromium/issues/detail?id=638494

    this.useBlobFallback = false;
  }
  componentDidMount() {
    var getDownloadWorker = this.props.getDownloadWorker;
    getDownloadWorker().then(sw => {
      log.info('found active service worker');
      this.sw = sw;
      this.sw.postMessage('ping'); // just to activate the service worker
    }).catch(error => {
      // if service worker is not available, use blob as fallback to download table csv
      log.warn('Download csv is not optimized.', error);
      this.useBlobFallback = true;
    });
  }
  componentWillUnmount() {
    this.removeIframe();
    if (this.streamTimeout) clearTimeout(this.streamTimeout);
    if (this.snapshotHandlerTimeout) clearTimeout(this.snapshotHandlerTimeout);
  }
  createWriterStream(port) {
    // use blob fall back if it's safari
    var useBlob = this.useBlobFallback;
    var chunks = [];
    var encode = null;
    if (useBlob) {
      encode = TextEncoder.prototype.encode.bind(new TextEncoder());
    }
    var fileName = this.fileName;
    var streamConfig = {};
    if (useBlob) {
      streamConfig.write = chunk => {
        assertNotNull(encode);
        if (chunk.header !== undefined) {
          chunks.push(encode(chunk.header));
        }
        if (chunk.rows !== undefined) {
          chunks.push(encode(chunk.rows));
        }
      };
      streamConfig.close = () => {
        assertNotNull(fileName);
        var blob = new Blob(chunks, {
          type: 'application/octet-stream; charset=utf-8'
        });
        var link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      };
      streamConfig.abort = () => {
        port.postMessage({
          cancel: true
        });
        port.close();
      };
    } else {
      streamConfig.write = chunk => {
        port.postMessage(chunk);
      };
      streamConfig.close = () => {
        port.postMessage({
          end: true
        });
        port.close();
      };
      streamConfig.abort = () => {
        port.postMessage({
          cancel: true
        });
        port.close();
      };
    }
    return new WritableStream(streamConfig);
  }
  startDownload(fileName, frozenTable, tableSubscription, snapshotRanges, modelRanges, includeColumnHeaders, useUnformattedValues) {
    // don't trigger another download when a download is ongoing
    var isDownloading = this.props.isDownloading;
    if (isDownloading) {
      return;
    }
    this.downloadStartTime = Date.now();
    log.info("start downloading ".concat(fileName));
    this.table = frozenTable;
    this.columns = IrisGridUtils.columnsFromRanges(modelRanges, frozenTable.columns);
    this.tableSubscription = tableSubscription;
    this.gridRanges = snapshotRanges;
    this.includeColumnHeaders = includeColumnHeaders;
    this.useUnformattedValues = useUnformattedValues;

    // Make filename RFC5987 compatible
    var encodedFileName = encodeURIComponent(fileName.replace(/\//g, ':')).replace(/['()]/g, escape).replace(/\*/g, '%2A');
    var messageChannel = new MessageChannel();
    this.port = messageChannel.port1;
    this.fileName = fileName;
    this.fileWriter = this.createWriterStream(this.port).getWriter();

    // if the browser doesn't support stream or there's no active service worker, use blobs for table download
    if (this.useBlobFallback) {
      this.writeCsvTable(includeColumnHeaders);
      return;
    }
    if (this.sw) {
      // send file name and port to service worker
      this.sw.postMessage({
        encodedFileName
      }, [messageChannel.port2]);
    }
    this.port.onmessage = this.handlePortMessage;
  }
  finishDownload() {
    if (this.table) {
      this.table.close();
    }
    if (this.tableSubscription) {
      this.tableSubscription.close();
    }
    if (this.fileWriter) {
      this.fileWriter.close();
    }
    var onDownloadCompleted = this.props.onDownloadCompleted;
    onDownloadCompleted();
    this.resetTableSaver();
    if (this.downloadStartTime !== undefined) {
      log.info("download finished, total elapsed time ".concat((Date.now() - this.downloadStartTime) / 1000, " seconds"));
    }
  }
  cancelDownload() {
    var _this$table, _this$tableSubscripti, _this$fileWriter;
    (_this$table = this.table) === null || _this$table === void 0 || _this$table.close();
    (_this$tableSubscripti = this.tableSubscription) === null || _this$tableSubscripti === void 0 || _this$tableSubscripti.close();
    (_this$fileWriter = this.fileWriter) === null || _this$fileWriter === void 0 || _this$fileWriter.abort();
    this.cancelableSnapshots.forEach(cancelable => {
      if (cancelable) {
        cancelable.catch(() => null);
        cancelable.cancel();
      }
    });
    var onDownloadCanceled = this.props.onDownloadCanceled;
    onDownloadCanceled();
    this.resetTableSaver();
  }
  resetTableSaver() {
    this.table = undefined;
    this.tableSubscription = undefined;
    this.columns = undefined;
    this.chunkRows = undefined;
    this.removeIframe();
    this.gridRanges = [];
    this.gridRangeCounter = 0;
    this.rangedSnapshotsTotal = [];
    this.rangedSnapshotCounter = 0;
    this.includeColumnHeaders = true;
    this.useUnformattedValues = false;
    this.snapshotsTotal = 0;
    this.snapshotCounter = 0;
    this.snapshotsBuffer = new Map();
    this.currentSnapshotIndex = 0;
    this.snapshotPending = 0;
    this.cancelableSnapshots = [];
    if (this.streamTimeout != null) {
      clearTimeout(this.streamTimeout);
    }
    if (this.snapshotHandlerTimeout != null) {
      clearTimeout(this.snapshotHandlerTimeout);
    }
    this.streamTimeout = undefined;
    this.snapshotHandlerTimeout = undefined;
  }
  handleDownloadTimeout() {
    log.info('download canceled');
    this.cancelDownload();
  }
  writeTableHeader() {
    var _this$fileWriter2;
    var headerString = '';
    if (this.columns) {
      for (var i = 0; i < this.columns.length; i += 1) {
        headerString += this.columns[i].name;
        headerString += i === this.columns.length - 1 ? '\n' : ',';
      }
    }
    (_this$fileWriter2 = this.fileWriter) === null || _this$fileWriter2 === void 0 || _this$fileWriter2.write({
      header: headerString
    }).then(() => null);
  }
  startWriteTableBody() {
    if (this.columns && this.gridRanges != null) {
      this.chunkRows = Math.floor(TableSaver.DOWNLOAD_CELL_CHUNK / this.columns.length);
      this.rangedSnapshotsTotal = this.gridRanges.map(range => {
        assertNotNull(range.endRow);
        assertNotNull(range.startRow);
        assertNotNull(this.chunkRows);
        return Math.ceil((range.endRow - range.startRow + 1) / this.chunkRows);
      });
      this.snapshotsTotal = this.rangedSnapshotsTotal.reduce((total, snapshotCount) => total + snapshotCount);
      log.info("start writing table, total snapshots: ", this.snapshotsTotal);
      this.makeSnapshot(Math.min(TableSaver.SNAPSHOT_BUFFER_SIZE, this.snapshotsTotal));
    }
  }
  writeCsvTable(includeColumnHeaders) {
    if (includeColumnHeaders) {
      this.writeTableHeader();
    }
    this.startWriteTableBody();
  }
  writeSnapshot(snapshotIndex, snapshotStartRow, snapshotEndRow) {
    if (this.currentSnapshotIndex === snapshotIndex && this.fileWriter) {
      while (this.snapshotsBuffer.has(this.currentSnapshotIndex)) {
        var n = this.snapshotsBuffer.get(this.currentSnapshotIndex);
        assertNotNull(n);
        this.fileWriter.write({
          rows: this.convertSnapshotIntoCsv(n)
        });
        this.snapshotsBuffer.delete(this.currentSnapshotIndex);
        this.currentSnapshotIndex += 1;
        this.updateDownloadProgress(snapshotIndex);
      }
      if (this.snapshotsTotal && this.currentSnapshotIndex >= this.snapshotsTotal) {
        this.finishDownload();
        return;
      }
    }
    if (this.snapshotCounter && this.snapshotsTotal && this.snapshotCounter < this.snapshotsTotal) {
      log.debug2("\n        current range index: ".concat(this.gridRangeCounter, ", \n        snapshotIndexCounter: ").concat(this.snapshotCounter, ", \n        currentRangedSnapshotIndex : ").concat(this.rangedSnapshotCounter, ", \n        snapshotpending: ").concat(this.snapshotPending, ", \n        buffered ").concat(this.snapshotsBuffer.size, "\n        making ").concat(Math.min(TableSaver.SNAPSHOT_BUFFER_SIZE - this.snapshotsBuffer.size - this.snapshotPending, this.snapshotsTotal - this.snapshotCounter), " more snapshots\n        "));
      this.makeSnapshot(Math.min(TableSaver.SNAPSHOT_BUFFER_SIZE - this.snapshotsBuffer.size - this.snapshotPending, this.snapshotsTotal - this.snapshotCounter));
    }
  }
  updateDownloadProgress(snapshotIndex) {
    if (snapshotIndex != null && this.snapshotsTotal != null && this.downloadStartTime != null) {
      var onDownloadProgressUpdate = this.props.onDownloadProgressUpdate;
      var downloadProgress = Math.floor(snapshotIndex * 100 / this.snapshotsTotal);
      var estimateTime = snapshotIndex > 1 ? Math.floor((Date.now() - this.downloadStartTime) * (this.snapshotsTotal - snapshotIndex) / snapshotIndex / 1000) : null;
      onDownloadProgressUpdate(downloadProgress, estimateTime);
    }
  }
  convertSnapshotIntoCsv(snapshot) {
    var csvString = '';
    var snapshotIterator = snapshot.added.iterator();
    var _this$props = this.props,
      dh = _this$props.dh,
      formatter = _this$props.formatter;
    var rows = [];
    while (snapshotIterator.hasNext()) {
      rows.push(snapshotIterator.next().value);
    }
    assertNotNull(this.columns);
    var useUnformattedValues = this.useUnformattedValues;
    for (var i = 0; i < rows.length; i += 1) {
      var rowIdx = rows[i];
      for (var j = 0; j < this.columns.length; j += 1) {
        var _this$columns$j = this.columns[j],
          type = _this$columns$j.type,
          name = _this$columns$j.name;
        var cellData = null;
        if (useUnformattedValues) {
          var _snapshot$getData;
          var value = (_snapshot$getData = snapshot.getData(rowIdx, this.columns[j])) !== null && _snapshot$getData !== void 0 ? _snapshot$getData : '';
          if (value !== '' && TableUtils.isDateType(type)) {
            // value is just a long value, we should return the value formatted as a full date string
            value = dh.i18n.DateTimeFormat.format(UNFORMATTED_DATE_PATTERN, value, dh.i18n.TimeZone.getTimeZone(formatter.timeZone));
          }
          cellData = value.toString();
        } else {
          var hasCustomColumnFormat = this.getCachedCustomColumnFormatFlag(formatter, name, type);
          var formatOverride = null;
          if (!hasCustomColumnFormat) {
            var cellFormat = snapshot.getFormat(rowIdx, this.columns[j]);
            formatOverride = (cellFormat === null || cellFormat === void 0 ? void 0 : cellFormat.formatString) != null ? cellFormat : null;
          }
          if (formatOverride) {
            cellData = formatter.getFormattedString(snapshot.getData(rowIdx, this.columns[j]), type, name, formatOverride);
          } else {
            cellData = formatter.getFormattedString(snapshot.getData(rowIdx, this.columns[j]), type, name);
          }
        }
        csvString += TableSaver.csvEscapeString(cellData);
        csvString += j === this.columns.length - 1 ? '\n' : ',';
      }
    }
    return csvString;
  }
  makeSnapshot(n) {
    var _this = this;
    if (n <= 0) {
      return;
    }
    var dh = this.props.dh;
    assertNotNull(this.gridRangeCounter);
    var i = 0;
    var currentGridRange = this.gridRanges[this.gridRangeCounter];
    assertNotNull(this.tableSubscription);
    assertNotNull(this.columns);
    var _loop = function _loop() {
      assertNotNull(currentGridRange);
      assertNotNull(currentGridRange.startRow);
      assertNotNull(currentGridRange.endRow);
      assertNotNull(_this.rangedSnapshotCounter);
      assertNotNull(_this.chunkRows);
      var snapshotStartRow = currentGridRange.startRow + _this.rangedSnapshotCounter * _this.chunkRows;
      var snapshotEndRow = Math.min(snapshotStartRow + _this.chunkRows - 1, currentGridRange.endRow);
      var snapshotIndex = _this.snapshotCounter;
      _this.cancelableSnapshots.push(PromiseUtils.makeCancelable(_this.tableSubscription.snapshot(dh.RangeSet.ofRange(snapshotStartRow, snapshotEndRow), _this.columns).then(snapshot => {
        assertIsUpdateEventData(snapshot);
        _this.handleSnapshotResolved(snapshot, snapshotIndex, snapshotStartRow, snapshotEndRow);
        return snapshotIndex;
      }).catch(err => {
        log.error(err);
      }), val => {
        log.info("snapshot ".concat(val, " has been canceled"));
      }));
      _this.rangedSnapshotCounter += 1;
      _this.snapshotCounter += 1;
      _this.snapshotPending += 1;
      if (_this.rangedSnapshotCounter >= _this.rangedSnapshotsTotal[_this.gridRangeCounter]) {
        _this.gridRangeCounter += 1;
        _this.rangedSnapshotCounter = 0;
        currentGridRange = _this.gridRanges[_this.gridRangeCounter];
      }
      i += 1;
    };
    while (i < n) {
      _loop();
    }
  }
  handlePortMessage(_ref) {
    var data = _ref.data;
    var download = data.download,
      readableStreamPulling = data.readableStreamPulling;
    if (this.useBlobFallback) {
      return;
    }
    if (download != null) {
      var includeColumnHeaders = this.includeColumnHeaders;
      this.makeIframe("".concat(download));
      this.writeCsvTable(includeColumnHeaders);
    }
    if (readableStreamPulling != null) {
      if (!this.useBlobFallback) {
        if (this.streamTimeout != null) {
          clearTimeout(this.streamTimeout);
        }
        this.streamTimeout = setTimeout(this.handleDownloadTimeout, TableSaver.STREAM_TIMEOUT);
      }
    }
  }
  handleSnapshotResolved(snapshot, snapshotIndex, snapshotStartRow, snapshotEndRow) {
    // use time out to break writeSnapshot into an individual task in browser with timeout, so there's window for the browser to update table in needed.
    this.snapshotHandlerTimeout = setTimeout(() => {
      this.snapshotsBuffer.set(snapshotIndex, snapshot);
      this.snapshotPending -= 1;
      this.writeSnapshot(snapshotIndex, snapshotStartRow, snapshotEndRow);
      this.cancelableSnapshots[snapshotIndex] = null;
    }, TableSaver.SNAPSHOT_HANDLER_TIMEOUT);
  }
  makeIframe(src) {
    // make a return value and make it static method
    var iframe = document.createElement('iframe');
    iframe.hidden = true;
    iframe.src = src;
    iframe.name = 'iframe';
    document.body.appendChild(iframe);
    this.iframe = iframe;
  }
  removeIframe() {
    var _this$iframe;
    (_this$iframe = this.iframe) === null || _this$iframe === void 0 || _this$iframe.remove();
    this.iframe = undefined;
  }
  render() {
    return null;
  }
}
_defineProperty(TableSaver, "DOWNLOAD_CELL_CHUNK", 6000);
_defineProperty(TableSaver, "SNAPSHOT_BUFFER_SIZE", 5);
_defineProperty(TableSaver, "STREAM_TIMEOUT", 8000);
_defineProperty(TableSaver, "SNAPSHOT_HANDLER_TIMEOUT", 5);
_defineProperty(TableSaver, "defaultProps", {
  isDownloading: false,
  onDownloadCompleted: () => undefined,
  onDownloadCanceled: () => undefined,
  onDownloadProgressUpdate: () => undefined
});
//# sourceMappingURL=TableSaver.js.map